import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController, NavParams, ModalController, Modal, LoadingController, Loading } from 'ionic-angular';
import { APIOnLine } from "../../services/api/api.services";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { Proxy } from '../../services/proxy/proxy.service';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { ModalImagePage } from '../modal-image/modal-image';

@IonicPage()
@Component({
  selector: 'page-nueva-persona',
  templateUrl: 'nueva-persona.html',
})
export class NuevaPersonaPage {

  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public esEntrenador: boolean;
  public esAuxiliar: boolean;
  public esOtroAuxiliar: boolean = false;
  public delegadoEquipo: boolean;
  public delegadoCampo: boolean;

  public identificador: string = "";
  public inhabilitada: boolean = false;
  public ListaSituaciones: Array<Proxy.PrPersonaAlineable> = [];
  public persona: Proxy.PrPersonaAlineable;

  // #region Propiedades cuando no se ha encontrado la persona por su DNI
  public nuevaPersona: Proxy.PrPersonaAlineable;
  public dniNoEncontrado: boolean = false;
  // #endregion

  constructor(
    public navCtrl: NavController,
    public NavParams: NavParams,
    public modalCtrl: ModalController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController
  ) {

  }

  ionViewDidLoad() {
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();
    this.esEntrenador = <boolean>this.NavParams.get("esEntrenador");
    this.esAuxiliar = <boolean>this.NavParams.get("esAuxiliar");
    this.esOtroAuxiliar = this.NavParams.get("esOtroAuxiliar") != null ? <boolean>this.NavParams.get("esOtroAuxiliar") : false;
    this.delegadoCampo = this.NavParams.get("delegadoCampo") != null ? <boolean>this.NavParams.get("delegadoCampo") : false;
    this.delegadoEquipo = this.NavParams.get("delegadoEquipo") != null ? <boolean>this.NavParams.get("delegadoEquipo") : false;

    console.log("Búsqueda de delegado de equipo: " + this.delegadoEquipo);
    console.log("Búsqueda de delegado de campo: " + this.delegadoCampo);
    console.log("Búsqueda de otros auxiliares", this.esOtroAuxiliar);

    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.persona = new Proxy.PrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes);

    this.participantes.CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(this.esAuxiliar || this.esEntrenador ? false : true, this.esEntrenador, this.esAuxiliar);
      })
      .then((resultado: boolean) => {
        this.Inicializar();
      })
      .catch(error => console.error(error));
  }

  // #region Métodos del controlador

  public Buscar(ngForm: NgForm): void {
    if (ngForm.valid) {
      let licenciaEnAlineables: boolean = false;
      let personaAlineada: Proxy.PrPersonaAlineable = this.licencias != null && this.licencias.AlineablePorIdentificador(this.identificador) != null
        ? this.licencias.AlineablePorIdentificador(this.identificador)
        : null;

      this.inhabilitada = false;
      this.ListaSituaciones = [];
      this.dniNoEncontrado = false;

      // Si se encuentra el DNI en la lista de personas alineables, no debería permitirse añadir como persona,
      // siempre y cuando no se esté añadiendo a un delegado de campo y dicha licencia sea auxiliar
      if (personaAlineada != null && (!this.delegadoCampo || (this.delegadoCampo && !personaAlineada.esAuxiliar))) {
        licenciaEnAlineables = true;
      }

      // Si el DNI está en la lista de alineables y no se cumplen las condiciones para no tenerlo en cuenta, hay que devolver
      // un mensaje que indique que la persona ya está en la lista de alineables.
      if (licenciaEnAlineables) {
        const toast = this.toastCtrl.create({
          message: 'El DNI indicado ya figura en la lista de personas alineables del equipo.',
          duration: 5000
        });
        toast.present();
      }
      else {
        let carga: Loading = this.loadingCtrl.create({
          spinner: 'dots',
          content: "buscando"
        });
        carga.present();

        this.persona.SituacionesPorDNI(this.designacion.urlApi, this.identificador)
          .then((resultado: Array<Proxy.PrPersonaAlineable>) => {

            carga.dismiss();

            // Se comprueba si se han devuelto situaciones y si estas coinciden con el tipo de licencia buscada: jugador, entrenador o auxiliar
            if (resultado != null && resultado.length > 0) {
              console.log(resultado);

              // Para la búsqueda de licencias de auxiliares, se debe permitar también la selección de entrenadores
              resultado.forEach((valor: Proxy.PrPersonaAlineable) => {

                // Diferentes casos que se pueden dar para comprobar si se añade la situación encontrada en la lista de situaciones a mostrar
                // 1.- Jugador
                if (!this.esAuxiliar && !this.esEntrenador && !valor.esAuxiliar && !valor.esEntrenador) {
                  this.ListaSituaciones.push(valor);
                }
                // 2.- Entrenador
                else if (!this.esAuxiliar && this.esEntrenador && valor.esEntrenador) {
                  this.ListaSituaciones.push(valor);
                }
                // 3.- Delegado
                else if (this.esAuxiliar) {
                  // Para los auxiliares, hay más posibilidades.
                  // 3.1.- Se busca delegados de equipo. Para estos, los únicos que pueden ser delegados de equipo, son aquellos que tengan ese tipo de licencia, excluyendo los que sean DELEGADOS DE CAMPO
                  if (this.delegadoEquipo && valor.esAuxiliar && valor.tipoLicencia.trim().indexOf('DELEGADO') >= 0 && valor.tipoLicencia.trim().indexOf('DELEGADO DE CAMPO') < 0) {
                    this.ListaSituaciones.push(valor);
                  }
                  // 3.2.- Se busca delegados de campo. Cualquier persona con situación deportiva puede ser delegado de campo.
                  else if (this.delegadoCampo) {
                    this.ListaSituaciones.push(valor);
                  }
                }
              });

              if (this.ListaSituaciones.length > 0) {
                // Se comprueba si la persona tiene una inhabilitación.
                this.ListaSituaciones[0].PersonaInhabilitada()
                  .then((resultado: boolean) => {
                    console.log(resultado);
                    this.inhabilitada = resultado;
                  })
                  .catch(error => console.error(error));
              }
              else {
                const toast = this.toastCtrl.create({
                  message: 'La situación deportiva encontrada, no coincide con el tipo de licencia buscada.',
                  duration: 5000
                });
                toast.present();
              }
            }
            else {
              this.dniNoEncontrado = true;
              this.InicializarNuevaPersona(this.identificador);
            }
          })
          .catch(error => console.error(error));
      }
    }
  }

  // Guarda como alineado la persona pasada como parámetro
  public Guardar(persona: Proxy.PrPersonaAlineable): void {

    // En el caso de que lo que se desee guardar es una situación de auxiliar (delegado), se fuerza para que la licencia sea de ese tipo
    if (this.esAuxiliar && this.delegadoCampo) {
      persona.esAuxiliar = true;
      persona.esEntrenador = false;
      persona.idTipoLicencia = 0;
      persona.sinLicencia = true;
      persona.categoria = "";
      persona.codigoTipoLicencia = "DC";
      persona.codigoBarras = "DC";
      persona.tipoLicencia = "DELEGADO CAMPO";
    }

    persona.idEquipo = this.idEquipo;
    persona.urlApi = this.designacion.urlApi;
    persona.urlNombre = this.designacion.urlNombre;

    console.log("Persona a guardar");
    console.log(persona);

    persona.Guardar(this.designacion.idDesignacion)
      .then((resultado: Proxy.PrPersonaAlineable) => {
        console.log("Nueva persona añadida como alineada");
        console.log(resultado);
        this.navCtrl.pop();
      })
      .catch(error => console.error(error));
  }

  private Inicializar(): void {
    this.identificador = "";
    this.inhabilitada = false;
    this.ListaSituaciones = [];
    this.dniNoEncontrado = false;
  }

  public VerFoto(persona: Proxy.PrPersonaAlineable): void {
    let modal: Modal = this.modalCtrl.create(ModalImagePage, {
      dni: persona.identificador
    });
    modal.present();
  }

  // #endregion

  // #region Métodos para la inserción de una nueva persona, cuando no se ha encontrado por DNI

  private InicializarNuevaPersona(identificador: string): void {
    this.nuevaPersona = new Proxy.PrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes);
    this.nuevaPersona.idAlineado = 0;
    this.nuevaPersona.identificador = identificador;
    this.nuevaPersona.codigoTipoLicencia = this.esEntrenador ? 'E' : (this.esAuxiliar ? 'D' : '');
    this.nuevaPersona.esAuxiliar = this.esAuxiliar || this.esOtroAuxiliar;
    this.nuevaPersona.esEntrenador = this.esEntrenador;
    this.nuevaPersona.esNacional = false;
    this.nuevaPersona.idEquipo = this.idEquipo;
    this.nuevaPersona.idDesignacion = this.designacion.idDesignacion;
    this.nuevaPersona.sinLicencia = true;
    this.nuevaPersona.urlApi = this.designacion.urlApi;
    this.nuevaPersona.urlNombre = this.designacion.urlNombre;

    if (this.delegadoCampo) {
      this.nuevaPersona.categoria = "";
      this.nuevaPersona.codigoTipoLicencia = "DC";
      this.nuevaPersona.codigoBarras = "DC";
      this.nuevaPersona.tipoLicencia = "DELEGADO CAMPO";
    }
  }

  // Inserta los datos de la nueva persona, si el formulario es válido
  public Insertar(ngForm: any): void {
    if (ngForm.valid) {

      // Conversión del tipo de licencia a 'codigoLicencia' para que se guarde en el campo del mismo nombre de la tabla ACTAS_ALINEADOS
      if (this.esOtroAuxiliar) {
        this.nuevaPersona.codigoBarras = this.nuevaPersona.tipoLicencia;
      }

      this.nuevaPersona.Guardar(this.designacion.idDesignacion)
        .then((resultado: Proxy.PrPersonaAlineable) => {
          console.log("Alineado guardado", this.nuevaPersona);
          this.navCtrl.pop();
        })
        .catch(error => console.error(error));
    }
  }

  // #endregion

}



// WEBPACK FOOTER //
// ./src/pages/nueva-persona/nueva-persona.ts